var map = {
	"./Donlon.png": [
		59,
		4
	],
	"./Enchai.png": [
		60,
		5
	],
	"./Jebing.png": [
		61,
		6
	],
	"./Lerbin.png": [
		62,
		7
	],
	"./Pingasor.png": [
		63,
		8
	],
	"./Sapir.png": [
		64,
		9
	],
	"./dummy_planet.png": [
		65,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 54;
module.exports = webpackAsyncContext;